
export class MarkerClusterEvent {

    public data?: any;
    public clientX?: number;
    public clientY?: number;
    public position: Position;

    constructor(obj: Partial<MarkerClusterEvent>) {
        Object.assign(this, obj);
    }

}
